import Http from "./http";
import {
    getFingerprint,
    getParam
} from './utils';

export default class Api {
    constructor(Wheel) {
        const id = this.id = Wheel.id;
        const uid = this.uid = Wheel.WHEEL_ID;
        let NUMBER_LIMIT_PLAYER = 20;
        this.http = new Http();
        this.BASE_URL = Wheel.SERVER_URL;
        this.SETTING_ENDPOINT = this.BASE_URL + '/api.wheel/' + uid + '/setting';
        this.LOGIN_NO_AUTH_ENDPOINT = this.BASE_URL + '/api.player/auth/no-auth/signin';
        this.LOGIN_PLAY_CODE_ENDPOINT = this.BASE_URL + '/api.player/auth/playcode/signin';
        this.LOGIN_MANY_CHAT_ENDPOINT = this.BASE_URL + '/api.player/auth/manychat/signin';
        this.LOGIN_HARAVAN_ENDPOINT = this.BASE_URL + '/api.haravan/signin';
        this.LOGIN_SAPO_ENDPOINT = this.BASE_URL + '/api.sapo/signin';
        this.REWARD_ENDPOINT = this.BASE_URL + '/api.reward/' + uid + '/reward';

        //game LuckyDraw
        this.FETCH_USERS = this.BASE_URL + '/api.player/game/list/' + id;
        this.FETCH_PRIZE = this.BASE_URL + '/api.item?wheel_id=' + id;
        this.GET_REWARDS = this.BASE_URL + '/api.reward?wheel_id=' + id;
        this.CONFIRM_PRIZE = this.BASE_URL + '/api.reward/' + uid + '/claim/award';

        this.CLAIM_REWARD_ENDPOINT = this.BASE_URL + '/api.reward/' + uid + '/claim';
        this.FETCH_MISSION_ENDPOINT = this.BASE_URL + '/api.mission/' + id;
        this.FETCH_DATA_MISSION_ENDPOINT = this.BASE_URL + '/api.wheel/' + id + '/mission-data';
        this.MISSION_COMPLETE_ENDPOINT = this.BASE_URL + '/api.mission/';
        this.AWARD_ENDPOINT = this.BASE_URL + '/api.reward/{{REWARD_ID}}/award';
        this.UPDATE_USER_INFO_ENDPOINT = this.BASE_URL + '/api.reward/{{REWARD_ID}}/info';
        this.GET_TOP_PLAYER_ENDPOINT = this.BASE_URL + '/api.point/top10/' + id + '/?limit=' + NUMBER_LIMIT_PLAYER;
        this.GET_MY_RANK_ENDPOINT = this.BASE_URL + '/api.point/rank/my/' + id;
        this.GET_HISTORY_PLAYER_POINT = this.BASE_URL + '/api.point/' + uid;
        this.UPDATE_PLAYER_INFO_ENDPOINT = this.BASE_URL + '/api.player/game/me';
        this.GET_PLAYER_INFO_ENDPOINT = this.BASE_URL + '/api.player/game/me';
        this.FETCH_TURN_ENDPOINT = this.BASE_URL + '/api.turn/' + id + '/count';
        this.CREATE_PLAYER_POINT_ENDPOINT = this.BASE_URL + '/api.custom/' + id + '/point';
        this.GET_VIEW_VISIT_ENDPOINT = this.BASE_URL + '/api.view/' + id + '/visit';
        this.GET_TURN_COUNT = this.BASE_URL + '/api.turn/' + id + '/me';
        this.CANCEL_AWARD_ENDPOINT = this.BASE_URL + '/api.reward/{{REWARD_ID}}/cancel';
        this.GET_QUIZ_ENDPOINT = this.BASE_URL + '/api.quiz/';
        this.SUBMIT_ANSWER_ENDPOINT = this.BASE_URL + '/api.quiz/submit-answer';
        this.anti_spam = Wheel.anti_spam;
    }

    async loginNoAuth(formData) {
        const url = this.LOGIN_NO_AUTH_ENDPOINT;
        const postData = Object.assign({}, {
            game_uid: this.uid,
        }, formData);
        const key = await this.getKey(formData)
        postData['key'] = key;
        postData['device_uid'] = await getFingerprint();
        return this.http.post(url, postData)
            .then((resp) => {
                if (resp && resp.data) {
                    return resp.data;
                } else {
                    throw new Error(JSON.stringify(resp));
                }
            })
    }
    async loginPlayCode(playCode) {
        const url = this.LOGIN_PLAY_CODE_ENDPOINT;
        const postData = Object.assign({}, {
            game_uid: this.uid,
            code: playCode
        });
        const key = await this.getKey(postData)
        postData['key'] = key;
        postData['device_uid'] = await getFingerprint();
        return this.http.post(url, postData)
            .then((resp) => {
                if (resp && resp.data) {
                    return resp.data;
                } else {
                    throw new Error(JSON.stringify(resp));
                }
            })
    }
    async loginManyChat(data) {
        const postData = Object.assign({}, {
            game_uid: this.uid,
        }, data);
        return this.http.post(this.LOGIN_MANY_CHAT_ENDPOINT, postData)
            .then((resp) => {
                if (resp && resp.data) {
                    return resp.data;
                } else {
                    throw new Error(JSON.stringify(resp));
                }
            })
    }

    async loginHaravan(phone, orderNumber, orderId) {
        const url = this.LOGIN_HARAVAN_ENDPOINT;
        const postData = Object.assign({}, {
            phone: phone,
            game_uid: this.uid,
            order_number: orderNumber,
            order_id: orderId
        });
        const key = await this.getKey(postData)
        postData['key'] = key;
        postData['device_uid'] = await getFingerprint();
        return this.http.post(url, postData)
            .then(resp => {
                if (!resp & resp.data) return
                return resp.data;
            })
    }

    async loginSapo(phone, orderNumber, orderId) {
        const url = this.LOGIN_SAPO_ENDPOINT;
        const postData = Object.assign({}, {
            phone: phone,
            game_uid: this.uid,
            order_number: orderNumber,
            order_id: orderId
        });
        const key = await this.getKey(postData)
        postData['key'] = key;
        postData['device_uid'] = await getFingerprint();
        return this.http.post(url, postData)
            .then(resp => {
                if (!resp & resp.data) return
                return resp.data;
            })
    }

    getRewards() {
        return this.http.get(this.GET_REWARDS)
            .then(resp => resp.data)
    }

    confirmPirze(postData){
        this.http.post(this.CONFIRM_PRIZE, postData)
            .then(resp => {
                if (!resp & resp.data) return
                return resp.data;
            })
    }
    getQuizData(turn_id) {
        const postData = {
            turn_id: turn_id
        }
        return this.http.post(this.GET_QUIZ_ENDPOINT, postData)
            .then(resp => resp.data)
    }

    submitAnswer(answerId, playedTime, turnId) {
        const postData = Object.assign({}, {
            game_id: this.id,
            answer: answerId || 0,
            played_time: playedTime || 0,
            turn_id: turnId
        })
        return this.http.post(this.SUBMIT_ANSWER_ENDPOINT, postData)
            .then(function (resp) {
                console.log('data', resp.data);
                return resp.data
            })
    }


    fetchRewards() {
        return this.http.get(this.REWARD_ENDPOINT)
            .then(resp => resp.data)
    }

    fetchUsers() {
        return this.http.get(this.FETCH_USERS)
            .then(resp => resp.data)
    }

    fetchPrize() {
        return this.http.get(this.FETCH_PRIZE)
            .then(resp => resp.data)
    }

    claimReward() {
        return this.http.post(this.CLAIM_REWARD_ENDPOINT, {})
            .then(resp => {
                if (resp && resp.data) {
                    return resp.data;
                } else {
                    throw new Error(JSON.stringify(resp));
                }
            })
    }

    awardReward(REWARD_ID, userInfo) {
        const url = this.AWARD_ENDPOINT.replace('{{REWARD_ID}}', REWARD_ID);
        let wref = '';
        let postData = {};
        if (getParam('wref')) {
            wref = parseInt(getParam('wref'))
        }
        if (wref) {
            postData = Object.assign({}, {
                "referral_id": wref
            }, userInfo);
        }
        return this.http.post(url, postData)
            .then(resp => resp.data)
    }
    cancelReward(REWARD_ID) {
        const url = this.CANCEL_AWARD_ENDPOINT.replace('{{REWARD_ID}}', REWARD_ID);
        return this.http.post(url)
            .then(resp => resp.data)
    }
    fetchMission() {
        return this.http.get(this.FETCH_MISSION_ENDPOINT)
            .then(resp => resp.data);
    }
    fetchAllMission() {
        return this.http.get(this.FETCH_DATA_MISSION_ENDPOINT)
            .then(resp => resp.data);
    }
    missionComplete(m_name, player_game_id, quantity) {
        return this.http.post(this.MISSION_COMPLETE_ENDPOINT, {
            name: m_name,
            player_game_id: player_game_id,
            game_uid: this.uid,
            quantity: quantity
        }).then(resp => {
            if (resp && resp.data) {
                return resp.data;
            } else {
                throw new Error(JSON.stringify(resp));
            }
        })
    }
    getTopPlayer(from, to) {
        var url = this.GET_TOP_PLAYER_ENDPOINT;
        if (from && to) {
            from = new Date(from);
            to = new Date(to);
            url += '&from=' + from.toISOString() + '&to=' + to.toISOString();
        }
        return this.http.get(url)
            .then(resp => resp.data)
    }
    getMyRank() {
        return this.http.get(this.GET_MY_RANK_ENDPOINT)
            .then(resp => resp.data)
    }
    updatePlayerInfo(data) {
        return this.http.put(this.UPDATE_PLAYER_INFO_ENDPOINT, data)
            .then(resp => {
                const data = resp.data
                if (data.jwt) {
                    this.http.setToken(data.jwt);
                }
                return data
            })
    }
    getPlayerInfo() {
        return this.http.get(this.GET_PLAYER_INFO_ENDPOINT)
            .then(resp => resp.data)
    }
    fetchTurn() {
        return this.http.get(this.FETCH_TURN_ENDPOINT)
            .then(resp => resp.data)
    }
    createPoint(payload) {
        return this.http.post(this.CREATE_PLAYER_POINT_ENDPOINT, payload)
            .then(resp => resp.data)
    }
    getHistoryPoint() {
        return this.http.get(this.GET_HISTORY_PLAYER_POINT)
            .then(resp => resp.data)
    }
    getViewVisit() {
        return this.http.get(this.GET_VIEW_VISIT_ENDPOINT)
            .then(resp => resp.data)
    }
    updateTurn() {
        return this.http.get(this.GET_TURN_COUNT)
            .then(resp => resp.data)
    }
    async getKey(form) {
        let fp;
        switch (this.anti_spam) {
            case 'phone':
                return form.phone;
            case 'email':
                return form.email;
            case 'device':
                fp = await getFingerprint();
                return fp;
            default:
                fp = await getFingerprint();
                return fp + ':' + Date.now();
        }
    }
}